import PropTypes from 'prop-types';

import { Heading, Link, List, ListItem, Paragraph } from '@cof/plastic-components';
import { css, styled } from 'styled-components';

import { withText } from '../../text/textStore';

export const SectionHeading = (props: any) => <Heading level="3" textAlign="left" {...props} />;
SectionHeading.displayName = 'SectionHeading';

export const ModalParagraphDivider = styled.div`
    ${({ theme }: any) => css`
        margin: ${theme.space.md} 0;
        border: solid 0.1rem ${theme.colors.global.grey50};

        ${theme.breakpoints.mq.tabletMin} {
            margin-top: ${theme.space.lg};
        }
    `};
`;
ModalParagraphDivider.displayName = 'ModalParagraphDivider';

export const ModalParagraph = (props: any) => <Paragraph size="small" mt="xs" p="0" {...props} />;
ModalParagraph.displayName = 'ModalParagraph';

export const ModalLink = (props: any) => <Link external size="small" {...props} />;
ModalLink.displayName = 'ModalLink';

const TermsAndConditionsModalView = ({ Text: text, JsxText }: any) => {
    return (
        <div data-qa-id="terms-and-conditions-modal-content">
            <Heading level="2" textAlign="left" data-qm-allow>
                {text({ path: 'Heading' })}
            </Heading>
            <SectionHeading data-qa-id="about-us-header" data-qm-allow>
                {text({ path: 'Section1.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="about-us-paragraph" data-qm-allow>
                {text({ path: 'Section1.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="search-service-header" data-qm-allow>
                {text({ path: 'Section2.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="search-service-paragraph" data-qm-allow>
                {text({ path: 'Section2.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="search-service-paragraph2" data-qm-allow>
                {text({ path: 'Section2.Paragraph2' })}
            </ModalParagraph>
            <List data-qa-id="search-service-list">
                <ListItem data-qa-id="search-service-list-item1" data-qm-allow>
                    {text({ path: 'Section2.List.Item1' })}
                </ListItem>
                <ListItem data-qa-id="search-service-list-item2" data-qm-allow>
                    {text({ path: 'Section2.List.Item2' })}
                </ListItem>
                <ListItem data-qa-id="search-service-list-item3" data-qm-allow>
                    {text({ path: 'Section2.List.Item3' })}
                    <List>
                        <ListItem data-qa-id="search-service-list-item3a" data-qm-allow>
                            {text({ path: 'Section2.SubList.Item1' })}
                        </ListItem>
                        <ListItem data-qa-id="search-service-list-item3b" data-qm-allow>
                            {text({ path: 'Section2.SubList.Item2' })}
                        </ListItem>
                    </List>
                </ListItem>
            </List>
            <ModalParagraph data-qa-id="search-service-paragraph3" data-qm-allow>
                {text({ path: 'Section2.Paragraph3' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="search-service-paragraph4" data-qm-allow>
                {text({ path: 'Section2.Paragraph4' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="privacy-and-cookies-header" data-qm-allow>
                {text({ path: 'Section3.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="privacy-and-cookies-paragraph" data-qm-allow>
                {text({ path: 'Section3.Paragraph1' })}
            </ModalParagraph>
            <List data-qa-id="privacy-and-cookies-list">
                <ListItem data-qa-id="privacy-and-cookies-list-item1" data-qm-allow>
                    <JsxText
                        path="Section3.List.Item1"
                        params={{
                            PRIVACY_POLICY_LINK: (
                                <ModalLink href={text({ path: 'Section3.PrivacyPolicyLink' })} data-qm-allow>
                                    Privacy Policy
                                </ModalLink>
                            )
                        }}
                    />
                </ListItem>
                <ListItem data-qa-id="privacy-and-cookies-list-item2" data-qm-allow>
                    <JsxText
                        path="Section3.List.Item2"
                        params={{
                            COOKIE_POLICY_LINK: (
                                <ModalLink href={text({ path: 'Section3.CookiePolicyLink' })} data-qm-allow>
                                    Cookie Policy
                                </ModalLink>
                            )
                        }}
                    />
                </ListItem>
            </List>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="duration-header" data-qm-allow>
                {text({ path: 'Section4.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="duration-paragraph" data-qm-allow>
                {text({ path: 'Section4.Paragraph1' })}
            </ModalParagraph>
            <List data-qa-id="duration-list">
                <ListItem data-qa-id="duration-list-item1" data-qm-allow>
                    {text({ path: 'Section4.List.Item1' })}
                </ListItem>
                <ListItem data-qa-id="duration-list-item2" data-qm-allow>
                    {text({ path: 'Section4.List.Item2' })}
                </ListItem>
                <ListItem data-qa-id="duration-list-item3" data-qm-allow>
                    {text({ path: 'Section4.List.Item3' })}
                </ListItem>
                <ListItem data-qa-id="duration-list-item4" data-qm-allow>
                    {text({ path: 'Section4.List.Item4' })}
                </ListItem>
            </List>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="use-of-services-header" data-qm-allow>
                {text({ path: 'Section5.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="use-of-services-paragraph" data-qm-allow>
                {text({ path: 'Section5.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="use-of-services-paragraph2" data-qm-allow>
                {text({ path: 'Section5.Paragraph2' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="use-of-services-paragraph3" data-qm-allow>
                {text({ path: 'Section5.Paragraph3' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="use-of-services-paragraph4" data-qm-allow>
                {text({ path: 'Section5.Paragraph4' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="intellectual-property-header" data-qm-allow>
                {text({ path: 'Section6.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="intellectual-property-paragraph" data-qm-allow>
                {text({ path: 'Section6.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="intellectual-property-paragraph2" data-qm-allow>
                {text({ path: 'Section6.Paragraph2' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="intellectual-property-paragraph3" data-qm-allow>
                {text({ path: 'Section6.Paragraph3' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="links-to-quickcheck-header" data-qm-allow>
                {text({ path: 'Section7.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="links-to-quickcheck-paragraph" data-qm-allow>
                {text({ path: 'Section7.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="limitation-of-liability-header" data-qm-allow>
                {text({ path: 'Section8.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="limitation-of-liability-paragraph" data-qm-allow>
                {text({ path: 'Section8.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="limitation-of-liability-paragraph2" data-qm-allow>
                {text({ path: 'Section8.Paragraph2' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="limitation-of-liability-paragraph3" data-qm-allow>
                {text({ path: 'Section8.Paragraph3' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="limitation-of-liability-paragraph4" data-qm-allow>
                {text({ path: 'Section8.Paragraph4' })}
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="contact-us-header" data-qm-allow>
                {text({ path: 'Section9.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="contact-us-paragraph" data-qm-allow>
                <JsxText
                    path="Section9.Paragraph1"
                    params={{
                        CONTACT_US_LINK: (
                            <ModalLink href={text({ path: 'Section9.ContactUsLink' })} data-qm-allow>
                                {text({ path: 'Section9.ContactUsLink' })}
                            </ModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraph data-qa-id="contact-us-paragraph2" data-qm-allow>
                <JsxText
                    path="Section9.Paragraph2"
                    params={{
                        HOMEPAGE_LINK: (
                            <ModalLink href="https://www.capitalone.co.uk" data-qm-allow>
                                www.capitalone.co.uk
                            </ModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraph data-qa-id="contact-us-paragraph3" data-qm-allow>
                <JsxText
                    path="Section9.Paragraph3"
                    params={{
                        OMBUDSMAN_EMAIL_LINK: (
                            <ModalLink href="mailto:complaint.info@financial-ombudsman.org.uk" data-qm-allow>
                                complaint.info@financial-ombudsman.org.uk
                            </ModalLink>
                        ),
                        OMBUDSMAN_LINK: (
                            <ModalLink href="http://www.financial-ombudsman.org.uk" data-qm-allow>
                                www.financial-ombudsman.org.uk
                            </ModalLink>
                        )
                    }}
                />
            </ModalParagraph>
            <ModalParagraphDivider />
            <SectionHeading data-qa-id="general-header" data-qm-allow>
                {text({ path: 'Section10.Heading' })}
            </SectionHeading>
            <ModalParagraph data-qa-id="general-paragraph" data-qm-allow>
                {text({ path: 'Section10.Paragraph1' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="general-paragraph2" data-qm-allow>
                {text({ path: 'Section10.Paragraph2' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="general-paragraph3" data-qm-allow>
                {text({ path: 'Section10.Paragraph3' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="general-paragraph4" data-qm-allow>
                {text({ path: 'Section10.Paragraph4' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="general-paragraph5" data-qm-allow>
                {text({ path: 'Section10.Paragraph5' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="general-paragraph6" data-qm-allow>
                {text({ path: 'Section10.Paragraph6' })}
            </ModalParagraph>
            <ModalParagraph data-qa-id="general-paragraph7" data-qm-allow>
                {text({ path: 'Section10.Paragraph7' })}
            </ModalParagraph>
            <ModalParagraphDivider />
        </div>
    );
};

TermsAndConditionsModalView.propTypes = {
    JsxText: PropTypes.func.isRequired,
    Text: PropTypes.func.isRequired
};

export default withText('TermsAndConditionsModalView')(TermsAndConditionsModalView);
